import React, { useState, useEffect } from "react";
import { CDBBtn } from 'cdbreact';

export const ModalViewPDF = ({ URL, setPressedButton }) => {
  const [pdfLink, setPdfLink] = useState(URL || "");

  useEffect(() => {
    setPdfLink(URL);
  }, [URL]);

  return (
    <div style={styles.modalContainer}>
      <div style={styles.modalHeader}>
        <h3 style={styles.modalTitle}>Visualizar PDF</h3>
      </div>
      <div style={styles.modalBody}>
      <iframe
        src={`https://docs.google.com/viewer?url=${encodeURIComponent(pdfLink)}&embedded=true`}
        title="PDF Viewer"
        width="100%"
        height="550px"
      ></iframe>
      </div>
      <div style={styles.modalFooter}>
        <CDBBtn
          type="button"
          color="danger"
          outline
          onClick={() => setPressedButton("closeModal")}
          style={styles.modalFooterBtn}
        >
          Cerrar
        </CDBBtn>
      </div>
    </div>
  );
};

// Estilos CSS
const styles = {
  modalContainer: {
    padding: 20,
    borderRadius: 10,
    background: "#ffffff",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "20px 0",
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "bold",
  },
  modalBody: {
    overflowY: "auto",
  },
  modalFooter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalFooterBtn: {
    margin: "10px 0",
  },
};